import React from 'react'
import styled from '@emotion/styled'
import { Banner } from 'src/components/molecules/Banner'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'

export const TopBanner = () => {
  return (
    <TopBannerView
      text="社内・パートナー企業とのコミュニケーションを支援する「commmune for Work」"
      link="https://commmune-work.com/"
    />
  )
}

const TopBannerView = styled(Banner)`
  padding: 0 20px;
  box-sizing: border-box;
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    height: 100%;
  }
`
